import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory, useParams } from 'react-router-dom';
import { ButtonPrimary, Container, Table } from './styles2';
import './style2.css';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';

export const Faltantes = () => {
  const [dados, setDados] = useState([]);
  const { id, periodo } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://inventario.dracherie.com.br/api_cherie/componentes_qr_code/comparacao.php?id_loja=${id}&id_periodo=${periodo}`);
        setDados(response.data.enderecos);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    fetchData();
  }, [id, periodo]);

  const dividirEmColunas = (dados, numeroDeColunas) => {
    const linhas = Math.ceil(dados.length / numeroDeColunas);
    const resultado = [];

    for (let i = 0; i < linhas; i++) {
      const linha = [];

      for (let j = 0; j < numeroDeColunas; j++) {
        const index = i * numeroDeColunas + j;
        if (index < dados.length) {
          linha.push(dados[index]);
        }
      }

      resultado.push(linha);
    }

    return resultado;
  };

  const dadosEmColunas = dividirEmColunas(dados, 10);

  const getColorForPrefix = (prefix) => {
    switch (prefix) {
      case 'E':
        return 'red';
      case 'L':
        return 'blue';
      case 'X':
        return 'gray';
      default:
        return 'black'; 
    }
  };

  return (
    <Container>
            <Navbar bg="light" expand="lg" className="w-100">
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to={`/exportacao/${id}/${periodo}`}>Voltar</Nav.Link>
              <Nav.Link as={Link} to="/qrcode">QR-Code</Nav.Link>
              <Nav.Link as={Link} to={`/periodo/${id}/${periodo}`}>Gerenciar Período</Nav.Link>
              <Nav.Link as={Link} to={`/pesquisa/${id}/${periodo}`}>Consultar Produto</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Table>
        <tbody>
          {dadosEmColunas.map((linha, rowIndex) => (
            <tr key={rowIndex}>
              {linha.map((endereco) => (
                <td className='td_fal' key={endereco.endereco_id} style={{ color: getColorForPrefix(endereco.endereco_nome.charAt(0)) }}>{endereco.endereco_nome}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default Faltantes;
